import React, {useEffect} from 'react'
import actions from 'redux-auto'
import {useSelector} from 'react-redux'
import {routeKeys} from '#config/routeKeys'
import HeaderIconButton from '#components/a/Header/HeaderIconButton'
import ChatIcon from '#components/svg/icons/ChatIcon'
import {useNavigate} from "react-router-dom";

function HeaderChatButton() {
  const hasNewActivities = useSelector(state => state.chat.hasNewActivities)
  const navigate = useNavigate()

  useEffect(() => {
    if (hasNewActivities === null) {
      actions.chat.getHasNewActivities()
    }
  })

  const navigateToChats = () => {
    navigate(routeKeys.chat)
  }

  return (
    <HeaderIconButton hasUpdates={hasNewActivities} onClick={navigateToChats} testId="headerChatButton">
      <ChatIcon />
    </HeaderIconButton>
  )
}

export default HeaderChatButton
